import React from "react";

import { Box, Row, StaticField } from "@intech/web-ui";

import { LoadingComponent } from "../../../../components/LoadingComponent";

interface IProps {
  saldo: any | null;
  primeiraCota: number;
}

export const SaldoInicial: React.FC<IProps> = ({
  saldo,
  primeiraCota
}) => {

  function DecimalDigitDisplay(Value: number, DecimalDigits: number) {
    if (Value === undefined)
      Value = 0;
    return (
      Value.toLocaleString('pt-br', { minimumFractionDigits: DecimalDigits, maximumFractionDigits: DecimalDigits })
    );
  }

  if (saldo !== null && saldo !== undefined) {
    return (
      <Box title={"Saldo Inicial"}>

        <Row form>
          <StaticField
            value={saldo.DS_PLANO}
            title={"Plano"}
            inline
            labelPosition={"up"}
          />

          <StaticField
            value={saldo.COD_CNPB}
            title={"CNPB"}
            inline
            labelPosition={"up"}
          />
        </Row>

        <Row form>
          <StaticField
            value={saldo.DS_ESPECIE}
            title={"Espécie de Benefício"}
            inline
            labelPosition={"up"}
          />

          <StaticField
            value={saldo.DT_INICIO_FUND}
            title={"Data de Início do Benefício"}
            inline
            labelPosition={"up"}
          />
        </Row>

        <Row form>
          <StaticField
            value={DecimalDigitDisplay(saldo.SALDO_INICIAL, 8)}
            title={"Saldo Inicial Constituído em Cotas"}
            inline
            labelPosition={"up"}
          />

          <StaticField
            value={(saldo.SALDO_INICIAL * primeiraCota)}
            title={"Saldo Inicial em Reais"}
            type={"money"}
            inline
            labelPosition={"up"}
          />
        </Row>

        <Row form>
          <StaticField
            value={DecimalDigitDisplay(saldo.VL_PERC_RESGATE, 2) + "%"}
            title={"% de Saque Antecipado"}
            inline
            labelPosition={"up"}
          />

          <StaticField
            value={DecimalDigitDisplay(saldo.VL_PARC_RESGATE, 8)}
            title={"Saque Antecipado em Cotas"}
            inline
            labelPosition={"up"}
          />
        </Row>

        <Row form>
          <StaticField
            value={DecimalDigitDisplay(saldo.SALDO_REVERSAO_BENEFICIO, 8)}
            title={"Saldo para Reversão em Benefício (em cotas)"}
            inline
            labelPosition={"up"}
          />
        </Row>
      </Box>
    )
  }

  return (
    <LoadingComponent />
  );
}